module.exports = __webpack_public_path__ + "img/aag-half.b6172ec6.png";